import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfirmDialogService } from './services/confirm-dialog-service/confirm-dialog.service';
import { LocalStorage } from './storage.class';

@Injectable()
export class CodaltInterceptor implements HttpInterceptor {
    public static loadingCount = 0;

    constructor(private confirmDialogService: ConfirmDialogService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        request = request.clone({
            setHeaders: {
                Authorization: 'Bearer ' + LocalStorage.getUserToken(),
                Accept: 'application/json',
                ...(LocalStorage.getLatestLocation() && { 'X-Latest-Location': LocalStorage.getLatestLocation() }),
            },
        });

        return next.handle(request).pipe(
            tap(
                response => {
                    if (response.type === HttpEventType.Sent) {
                        setTimeout(() => {
                            CodaltInterceptor.loadingCount++;
                        });
                    }
                    if (response.type === HttpEventType.Response) {
                        setTimeout(() => {
                            CodaltInterceptor.loadingCount--;
                        });
                    }
                },
                error => {
                    const errorMessage = error.error?.message;
                    if (error.status === 500 && errorMessage !== 'Too Many Attempts.') {
                        this.confirmDialogService.confirm({
                            title: 'Er is een fout opgetreden',
                            text: errorMessage || error.message,
                            confirm: 'Sluiten',
                            cancel: null,
                        });
                    }
                    setTimeout(() => {
                        CodaltInterceptor.loadingCount--;
                    });
                }
            )
        );
    }
}
